export const BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost:8080"
    : "https://fempulse-5930df9f9a5c.herokuapp.com";
